import Head from './head';
import './index.scss';
import { useEffect, useState, useRef, createContext } from 'react';
import { useHistory } from "react-router-dom";

export const ValueContext = createContext<boolean>(false);

const Index = (props) => {
    const history = useHistory();

    useEffect(() => {
        let path: any = sessionStorage.getItem('path')
        console.log(path)
        history.push(path);
        // setInterval(() => {
        //     console.log('111')
        //     history.push(`/conferenceRoom`);
        // }, 7000)
    }, [])

    return (
        <div className="wrapper">
            <Head />
            {props.children}
        </div>
    )
}

export default Index